export default __webpack_public_path__ + "static/media/14.ebc5e3de.jpg";